import React from 'react'
import ProductManagement from '../components/admin/ProductManagement'

const AdminProducts: React.FC = () => {
  return <ProductManagement />
}

export default AdminProducts